import i18next from '@/i18next';
export function tItems(key) {
    const data = i18next.store?.data?.[i18next.language]?.['marketing'];
    const parts = key.split('.');
    let node = data;
    for (const p of parts) {
        if (node === undefined)
            break;
        node = node[p];
    }
    return Array.isArray(node) ? node : [];
}
export const PLAN_LEVEL = {
    free: 0,
    solo: 1,
    team: 2,
};
export const PLANS_UI = [
    {
        code: 'free',
        nameKey: 'pricing.plans.free.name',
        priceKey: 'pricing.plans.free.price',
        descriptionKey: 'pricing.plans.free.description',
        itemsKey: 'pricing.plans.free.items',
        ctaKey: 'pricing.plans.free.cta',
    },
    {
        code: 'solo',
        highlighted: true,
        nameKey: 'pricing.plans.solo.name',
        priceKey: 'pricing.plans.solo.price',
        priceHintKey: 'pricing.plans.solo.priceHint',
        descriptionKey: 'pricing.plans.solo.description',
        itemsKey: 'pricing.plans.solo.items',
        ctaKey: 'pricing.plans.solo.cta',
    },
    {
        code: 'team',
        nameKey: 'pricing.plans.team.name',
        priceKey: 'pricing.plans.team.price',
        priceHintKey: 'pricing.plans.team.priceHint',
        descriptionKey: 'pricing.plans.team.description',
        itemsKey: 'pricing.plans.team.items',
        ctaKey: 'pricing.plans.team.cta',
    },
];
export const getPlanUi = (code) => PLANS_UI.find((p) => p.code === code) ?? PLANS_UI[0];
export const getPlanLevel = (code) => {
    if (!code)
        return PLAN_LEVEL.free;
    return PLAN_LEVEL[code] ?? PLAN_LEVEL.free;
};
const PLAN_STATIC_CONFIGS = [
    {
        code: 'free',
        featuresLabel: "What's included",
        footerNote: 'No credit card required.',
        monthly: { price: '$0' },
        annual: { price: '$0' },
        themesBadge: { themes: 15, animations: 15 },
        nameKey: 'pricing.plans.free.name',
        descriptionKey: 'pricing.plans.free.description',
        itemsKey: 'pricing.plans.free.items',
        ctaKey: 'pricing.plans.free.cta',
    },
    {
        code: 'solo',
        highlighted: true,
        featuresLabel: 'Everything in Free, plus',
        footerNote: 'Less than a coffee a week. Cancel anytime.',
        monthly: { price: '$9.99', priceHint: 'per month' },
        annual: { price: '$8.25', priceHint: 'per month', annualNote: 'Billed $99/year — save $20.88' },
        themesBadge: { themes: 35, animations: 42 },
        nameKey: 'pricing.plans.solo.name',
        descriptionKey: 'pricing.plans.solo.description',
        itemsKey: 'pricing.plans.solo.items',
        ctaKey: 'pricing.plans.solo.cta',
    },
    {
        code: 'team',
        featuresLabel: 'Everything in Solo, plus',
        footerNote: 'Cancel anytime.',
        monthly: { price: '$19.99', priceHint: 'per month' },
        annual: { price: '$16.58', priceHint: 'per month', annualNote: 'Billed $199/year — save $40.88' },
        themesBadge: { themes: 35, animations: 42 },
        nameKey: 'pricing.plans.team.name',
        descriptionKey: 'pricing.plans.team.description',
        itemsKey: 'pricing.plans.team.items',
        ctaKey: 'pricing.plans.team.cta',
    },
];
export const getPlans = (billing = 'monthly') => PLAN_STATIC_CONFIGS.map((plan) => {
    const pricing = billing === 'annual' ? plan.annual : plan.monthly;
    return {
        code: plan.code,
        highlighted: plan.highlighted,
        featuresLabel: plan.featuresLabel,
        footerNote: plan.footerNote,
        price: pricing.price,
        priceHint: pricing.priceHint,
        annualNote: pricing.annualNote,
        themesBadge: plan.themesBadge,
        name: i18next.t(plan.nameKey, { ns: 'marketing' }),
        description: i18next.t(plan.descriptionKey, { ns: 'marketing' }),
        items: tItems(plan.itemsKey),
        cta: i18next.t(plan.ctaKey, { ns: 'marketing' }),
    };
});
